import { Component } from '@angular/core';
import { AppState } from './services/app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public isAuthorized = false;

  constructor(private appState: AppState) {
    this.appState.user.subscribe((u) => {
      this.isAuthorized = u?.status === 'active';
    })
  }

  public logout() {
    this.appState.logOut();
  }
}
